import { isElement, isFragment } from 'react-is';
export function childrenToElementArray(children) {
    const childrenArray = Array.isArray(children) ? children : [children];
    return childrenArray.filter((node) => isElement(node) || isFragment(node) || typeof node === 'string');
}
//# sourceMappingURL=helpers.js.map